var React = require('react');

function SocialIconFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.7271 12.0447C24.7271 5.39188 19.3552 0 12.7271 0C6.09893 0 0.727051 5.39188 0.727051 12.0447C0.727051 17.6906 4.60361 22.4332 9.83018 23.7365V15.724H7.35518V12.0447H9.83018V10.4591C9.83018 6.36111 11.6771 4.4603 15.6896 4.4603C16.4489 4.4603 17.7614 4.61086 18.3005 4.76142V8.09253C18.0192 8.0643 17.5271 8.04548 16.913 8.04548C14.9442 8.04548 14.1849 8.79357 14.1849 10.7367V12.0447H18.1036L17.4286 15.724H14.1802V24C20.1239 23.2801 24.7271 18.2035 24.7271 12.0447Z","fill":"black"}));
}

SocialIconFacebook.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = SocialIconFacebook;

SocialIconFacebook.default = SocialIconFacebook;
